<template>
  <section class="promo">
    <div class="grid grid--container">
      <h3 class="promo__title h2">{{ title }}</h3>
      <p class="promo__text" v-if="text">{{ text }}</p>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    text: String,
  },
};
</script>

<style lang="scss" scoped>
.promo {
  background-color: var(--g-color-primary);
  background-image: url('~assets/images/mark-pattern-green.svg');
  background-repeat: repeat;
  background-size: 80px auto;
  color: #fff;
  padding: 5rem 0;
  text-align: center;
  font-size: 1.125rem;
}
</style>
